import { Link, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { API_BASE } from "../../utils/api";

export default function ProfileUsers() {
    const user = JSON.parse(localStorage.getItem("user"));
    const history = useHistory();
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const isSupervisor = user && user.groupId === "     9";
    useEffect(() => {
        // 🔒 protección mínima (TU criterio)
        if (!isSupervisor) {
            setLoading(false);
            return;
        }

        const fetchUsers = async () => {
            try {
                const url = `${API_BASE}/api-ultra/api/ws/ecommerce_users?id_customer=${user.idCustomer}`;

                const res = await fetch(url);
                const data = await res.json();

                setUsers(data || []);
            } catch (err) {
                console.error("Error cargando usuarios", err);
            } finally {
                setLoading(false);
            }
        };

        fetchUsers();
    }, [user]);

    return (
        <div className="max-w-6xl mx-auto mt-28 px-4">

            {/* HEADER */}

           <div className="flex items-center justify-between mb-6">
                <div>
                    <h1 className="text-2xl font-semibold mb-1">Gestión de usuarios</h1>
                    <p className="text-gray-500">
                         Administra los usuarios operativos de tu cuenta
                    </p>
                </div>

                <button
                    onClick={() => history.goBack()}
                    className="px-4 py-2 border rounded hover:bg-gray-100 transition text-sm"
                >
                    ← Regresar
                </button>
            </div>
            
            {/* ACCIONES */}
            <div className="flex justify-end mb-4">
                <Link
                    to="/profile/users/create"
                    className="px-4 py-2 rounded-md bg-brand-primary text-white text-sm hover:opacity-90"
                >
                    + Crear usuario
                </Link>
            </div>

            {/* TABLA */}
            <div className="bg-white border rounded-xl overflow-hidden">
                <table className="w-full text-sm">
                    <thead className="bg-gray-50 border-b">
                        <tr>
                            <th className="text-left px-4 py-3">Usuario</th>
                            <th className="text-left px-4 py-3">Nombres</th>
                            <th className="text-left px-4 py-3">Perfil</th>
                            <th className="text-left px-4 py-3">Estado</th>
                        </tr>
                    </thead>

                    <tbody>
                        {loading && (
                            <tr>
                                <td colSpan={4} className="px-4 py-6 text-center text-sm text-gray-400">
                                    Cargando usuarios...
                                </td>
                            </tr>
                        )}

                        {!loading && users.length === 0 && (
                            <tr>
                                <td colSpan={4} className="px-4 py-6 text-center text-sm text-gray-400">
                                    No hay usuarios registrados
                                </td>
                            </tr>
                        )}

                        {!loading && users.filter((u) => u.idEmployee !== user.idEmployee).map((u) => (
                            <tr
                                key={u.id_user}
                                className="border-t cursor-pointer hover:bg-gray-50"
                                onClick={() => history.push(`/profile/users/create/${u.idEmployee}`)}
                            >
                                <td className="px-4 py-3">{u.userId}</td>
                                <td className="px-4 py-3">{u.lastName} {u.firstName}</td>
                                <td className="px-4 py-3">{u.title}</td>
                                <td className="px-4 py-3">
                                    {!u.discontinued ? (
                                        <span className="text-green-600 text-xs font-medium">Activo</span>
                                    ) : (
                                        <span className="text-red-600 text-xs font-medium">Suspenso</span>
                                    )}
                                </td>

                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
